export const PATHNAME_HEADER = "x-pathname";

export const ALL_I18N_NAMESPACES = [
  "auth",
  "pdp",
  "checkout",
  "profile",
  "profile_menu",
  "validation",
  "button",
  "title",
  "label",
  "tag",
  "sell_component",
  "form",
  "slider",
  "home",
  "sell",
  "footer",
  "sell_bike",
  "message",
  "chat",
  "filters",
  "order_central",
  "shop",
  "metadata",
];

// Shipped on every route: header (search, nav, inbox icon, favourites, profile menu),
// footer, auth modal, app-download popup, toasts, and the shared form/validation
// vocabulary. `auth` must stay first — `initI18nInstance` derives `defaultNS` and
// `fallbackNS` from `namespaces[0]`.
const BASE_NAMESPACES = [
  "auth",
  "button",
  "title",
  "label",
  "tag",
  "message",
  "validation",
  "form",
  "footer",
  "metadata",
  "profile_menu",
  "chat",
  "slider",
  "filters",
  "home",
];

// Longest matching prefix wins, so "/profile/listings" resolves before "/profile".
// Locale prefix is stripped before matching.
const ROUTE_NAMESPACES: Record<string, string[]> = {
  "/shop": ["shop"],
  "/product": ["pdp", "shop", "checkout"],
  "/recommendation-products": ["pdp", "shop"],
  "/seller-profile": ["pdp", "shop", "profile"],
  "/checkout": ["checkout", "pdp"],
  "/claim-report": ["order_central"],
  "/contact-us": [],
  "/redeemvoucher": [],
  "/login": [],
  "/password": [],
  "/sell": ["sell", "sell_bike", "sell_component", "pdp"],
  "/profile": [
    "profile",
    "order_central",
    "pdp",
    "checkout",
    "sell",
    "sell_bike",
    "sell_component",
    "home",
  ],
};

const HOME_NAMESPACES = ["pdp", "shop"];

const stripLocale = (pathname: string) => {
  return pathname.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/, "") || "/";
};

// Serialising all 23 namespaces into every document costs ~173 KB raw in the RSC
// flight payload; the shop PLP uses ~60 KB of it. An unrecognised path falls back
// to the full list, so a new route renders correct copy before it is mapped here.
export const resolveI18nNamespaces = (pathname?: string | null): string[] => {
  if (!pathname) {
    return ALL_I18N_NAMESPACES;
  }

  const path = stripLocale(pathname);

  if (path === "/") {
    return Array.from(new Set([...BASE_NAMESPACES, ...HOME_NAMESPACES]));
  }

  const matched = Object.keys(ROUTE_NAMESPACES)
    .filter((prefix) => path === prefix || path.startsWith(`${prefix}/`))
    .sort((a, b) => b.length - a.length)[0];

  if (!matched) {
    return ALL_I18N_NAMESPACES;
  }

  return Array.from(
    new Set([...BASE_NAMESPACES, ...ROUTE_NAMESPACES[matched]]),
  );
};
